import { render } from "./ProjectUpdateModal.vue?vue&type=template&id=5e9e5ddb&scoped=true"
import script from "./ProjectUpdateModal.vue?vue&type=script&lang=js"
export * from "./ProjectUpdateModal.vue?vue&type=script&lang=js"

import "./ProjectUpdateModal.vue?vue&type=style&index=0&id=5e9e5ddb&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e9e5ddb"]])

export default __exports__